export const de = {
    translation: {
        common: {
            cancel: 'Abbrechen',
            close: 'Schließen',
            save: 'Speichern',
        },
        createOrganization: {
            welcome: {
                title: 'Willkommen bei {{productName}}',
                description:
                    'Lege in wenigen Schritten die Grundlage für deine Organisation an und wir richten den Arbeitsbereich passend für dich ein.',
                nameLabel: 'Name deiner Organisation',
                namePlaceholder: 'Gib den Namen deiner Organisation ein',
                start: 'Los geht’s',
            },
            organization: {
                badge: 'Organisationsdaten',
                title: 'Erzähl uns etwas mehr über {{organizationName}}',
                description:
                    'Damit richten wir die passenden Voreinstellungen, Begriffe und Abläufe für deinen Arbeitsbereich ein.',
                classificationTypeLabel: 'Art deiner Organisation',
                classificationTypePlaceholder: 'Bitte auswählen',
                classificationAreaLabel: 'Tätigkeitsbereich',
                classificationAreaPlaceholder: 'Bitte auswählen',
                sportsLabel: 'Sportarten',
                addressLabel: 'Adresse der Organisation',
                addressHint:
                    'Wir benötigen die Adresse, um länderspezifische Voreinstellungen, Dokumente, Steuereinstellungen und Organisationsdaten von Anfang an korrekt einzurichten.',
                continue: 'Weiter',
            },
            accounting: {
                title: 'Wie soll die Buchhaltung eingerichtet werden?',
                description:
                    'Lege fest, wie du die Buchhaltung für deine Organisation einrichten möchtest. Dies kann später nicht mehr geändert werden.',
                continue: 'Weiter',
                mode: {
                    options: {
                        none: {
                            title: 'Keine Buchhaltung',
                            description: 'Es wird keine Buchhaltung eingerichtet und verfügbar sein.',
                        },
                        export: {
                            title: 'Nur für das Exportieren',
                            description: 'Es werden automatisch Buchungen erstellt zum späteren Export.',
                        },
                        full: {
                            title: 'Volle Buchhaltung',
                            description: 'Nutze die vollen Buchhaltungsfunktionen direkt im Produkt.',
                        },
                    },
                },
                plan: {
                    label: 'Kontenrahmen',
                    placeholder: 'Bitte auswählen',
                    warning:
                        'Dieser Kontenrahmen kann nachträglich nicht mehr geändert werden. Wenn du später einen anderen verwenden möchtest, musst du eine neue Organisation anlegen.',
                },
                fiscalMonth: {
                    label: 'Beginn des Geschäftsjahres',
                },
                vatDueMethod: {
                    label: 'Art der Steuerfälligkeit',
                },
            },
            finish: {
                title: 'Du bist startklar',
                description: 'Glückwunsch, {{organizationName}} ist bereit zur Erstellung.',
                trial: 'Du kannst jetzt 14 Tage lang alles kostenlos im Testzeitraum ausprobieren.',
                memberSize: {
                    label: 'Erwartete Mitgliederzahl',
                    description: 'Diese Angabe wird verwendet, um die App weiter auf deine Organisation anzupassen.',
                },
                website: {
                    label: 'Website',
                    description:
                        'Füge deine Website hinzu, damit wir die Einrichtung besser an euren öffentlichen Auftritt anpassen können.',
                    error: 'Bitte gib eine gültige Website-URL inklusive https:// ein.',
                    noWebsite: 'Ich habe keine Website',
                },
                submit: 'Organisation jetzt erstellen',
                creating: 'Organisation wird erstellt...',
                success: {
                    title: 'Glückwunsch',
                    description:
                        'Deine Organisation ist bereit. Du kannst sie jetzt öffnen und direkt in der App weitermachen.',
                    link: 'Organisation jetzt öffnen',
                },
                error: 'Die Organisation konnte gerade nicht erstellt werden. Bitte versuche es erneut.',
            },
        },
        home: {
            title: 'Start',
            intro: 'Verwalte deine Organisationen und dein Profil in dieser App.',
            organizations: 'Deine Organisationen',
            description: 'Öffne eine Organisation in der passenden App oder erstelle eine neue.',
            searchPlaceholder: 'Organisationen suchen',
            createAction: 'Organisation erstellen',
            loadMore: 'Mehr laden',
            empty: {
                title: 'Eigene Organisation anlegen',
                description:
                    'Erstelle den passenden Ort für deine Organisation und erlebe {{productName}} mit allen Möglichkeiten.',
            },
            demo: {
                title: 'Live-Demo entdecken',
                description:
                    'Öffne eine vorbereitete Organisation und entdecke {{productName}} mit realistisch wirkenden Daten.',
            },
            searchEmpty: {
                title: 'Keine Organisationen gefunden',
                description: 'Passe deine Suche an, um eine Organisation zu finden.',
            },
            system: {
                title: 'System',
                description: 'Verwalte systemweite Einstellungen und Daten.',
                action: 'System öffnen',
            },
            community: {
                title: 'Community',
                description: 'Stelle Fragen und erhalte Hilfe von der Community rund um das Produkt',
                action: 'Community öffnen',
            },
            feedback: {
                title: 'Feedback',
                description: 'Lass uns teilhaben an Verbesserungen und neuen Funktionen für das Produkt',
                action: 'Feedback öffnen',
            },
            profileSummary: {
                bioEmpty: 'Füge eine kurze Bio hinzu, damit andere etwas über dich erfahren.',
                editAction: 'Profil bearbeiten',
                logoutAction: 'Abmelden',
            },
        },
        notifications: {
            panel: {
                title: 'Benachrichtigungen',
                loading: 'Benachrichtigungen werden geladen...',
                empty: 'Keine Benachrichtigungen gefunden',
                markAllRead: 'Alle als gelesen markieren',
                markRead: 'Als gelesen markieren',
                markUnread: 'Als ungelesen markieren',
                delete: 'Löschen',
                showDetails: 'Details anzeigen',
                unread: 'Ungelesen',
                all: 'Alle',
                categoryFilter: 'Kategorie',
                count_one: '{{count, number}} Benachrichtigung',
                count_other: '{{count, number}} Benachrichtigungen',
                countShowing: '{{shown, number}} von {{count, number}} Benachrichtigungen',
                loadMore: 'Mehr laden',
                detailsDialog: {
                    title: 'Benachrichtigungsdetails',
                },
            },
        },
        product: {
            feedback: {
                ticket: {
                    loading: 'Feedback-Ticket wird geladen',
                    number: 'Feedback-Ticket #{{number}}',
                    createdAt: 'Erstellt {{date}} von {{author}}',
                    status: 'Status',
                    upvoteAction: 'Dafür stimmen',
                    removeUpvoteAction: 'Stimme zurücknehmen',
                    votes_one: '{{count, number}} Stimme',
                    votes_other: '{{count, number}} Stimmen',
                    metadata: 'Status und Tags bearbeiten',
                    follow: 'Diesem Ticket folgen',
                    unfollow: 'Diesem Ticket nicht mehr folgen',
                    edit: 'Ticket bearbeiten',
                    delete: 'Ticket löschen',
                    comments_one: '{{count, number}} Kommentar',
                    comments_other: '{{count, number}} Kommentare',
                    reply: 'Kommentar hinzufügen',
                    deleteDialog: {
                        title: 'Feedback-Ticket löschen?',
                        message: '"{{title}}" und alle Kommentare löschen?',
                        confirm: 'Ticket löschen',
                    },
                    empty: {
                        title: 'Noch keine Kommentare',
                        description: 'Füge den ersten Kommentar hinzu, um die Diskussion fortzusetzen.',
                    },
                    metadataDialog: {
                        title: 'Status und Tags bearbeiten',
                        description: 'Verwalte interne Metadaten für dieses Feedback-Ticket.',
                        tags: 'Tags',
                        tagsPlaceholder: 'Tags durch Kommas getrennt hinzufügen',
                    },
                    commentDialog: {
                        titleCreate: 'Kommentar hinzufügen',
                        titleEdit: 'Kommentar bearbeiten',
                        description: 'Füge diesem Feedback-Ticket weitere Details hinzu.',
                        message: 'Kommentar',
                        create: 'Kommentar hinzufügen',
                    },
                    comment: {
                        edit: 'Kommentar bearbeiten',
                        delete: 'Kommentar löschen',
                        deleteDialog: {
                            title: 'Kommentar löschen?',
                            message: 'Diesen Feedback-Kommentar löschen?',
                            confirm: 'Kommentar löschen',
                        },
                    },
                },
                home: {
                    title: 'Feedback',
                    description: 'Lass uns teilhaben an Verbesserungen und neuen Funktionen für das Produkt',
                    create: 'Ticket erstellen',
                    searchPlaceholder: 'Tickets suchen',
                    ticketCount_one: '{{count, number}} Ticket',
                    ticketCount_other: '{{count, number}} Tickets',
                    ticketMeta: '#{{number}} erstellt {{createdAt}} von <author /> · aktualisiert {{latestActivityAt}}',
                    filters: {
                        status: 'Nach Status filtern',
                        sort: 'Tickets sortieren',
                        tag: 'Nach Tag filtern',
                    },
                    tagFilter: {
                        all: 'Alle Tags',
                        none: 'Ohne Tag',
                    },
                    statusFilter: {
                        all: 'Alle offenen',
                        new: 'Neu',
                        planned: 'Geplant',
                        inProgress: 'In Bearbeitung',
                        done: 'Erledigt',
                        rejected: 'Abgelehnt',
                    },
                    sort: {
                        latestActivity: 'Neueste Aktivität',
                        newest: 'Neueste',
                        oldest: 'Älteste',
                        mostVotes: 'Meiste Stimmen',
                        mostComments: 'Meiste Kommentare',
                    },
                    empty: {
                        title: 'Noch keine Feedback-Tickets',
                        description: 'Erstelle das erste Ticket, um Produktfeedback zu teilen.',
                    },
                    searchEmpty: {
                        title: 'Keine passenden Feedback-Tickets',
                        description: 'Passe deine Suche an, um ein Ticket zu finden.',
                    },
                },
                shared: {
                    status: {
                        new: 'Neu',
                        planned: 'Geplant',
                        inProgress: 'In Bearbeitung',
                        done: 'Erledigt',
                        rejected: 'Abgelehnt',
                    },
                    ticketDialog: {
                        titleCreate: 'Feedback-Ticket erstellen',
                        titleEdit: 'Feedback-Ticket bearbeiten',
                        description: 'Beschreibe das Produktfeedback, das du teilen möchtest.',
                        ticketTitle: 'Titel',
                        message: 'Nachricht',
                        create: 'Ticket erstellen',
                    },
                },
            },
            community: {
                category: {
                    loading: 'Kategorie wird geladen',
                    createTopic: 'Thema erstellen',
                    searchPlaceholder: 'Themen suchen',
                    openTopic: 'Thema öffnen',
                    createdAt: 'Erstellt {{date}}',
                    lastReplyAt: 'Letzte Antwort {{date}}',
                    topicCounts: '{{posts, number}} Antworten',
                    locked: 'Gesperrt',
                    readState: {
                        new: 'Neu',
                        updated: 'Aktualisiert',
                    },
                    sort: {
                        label: 'Themen sortieren',
                        newestTopics: 'Neueste Themen',
                        oldestTopics: 'Älteste Themen',
                        mostReplies: 'Meiste Antworten',
                        leastReplies: 'Wenigste Antworten',
                        newestReply: 'Neueste Antwort',
                        oldestReply: 'Älteste Antwort',
                    },
                    empty: {
                        title: 'Noch keine Themen',
                        description: 'Starte die erste Diskussion in dieser Kategorie.',
                    },
                    searchEmpty: {
                        title: 'Keine passenden Themen',
                        description: 'Passe deine Suche an, um ein Thema zu finden.',
                    },
                },
                topic: {
                    loading: 'Thema wird geladen',
                    actions: 'Themenaktionen',
                    edit: 'Thema bearbeiten',
                    delete: 'Thema löschen',
                    follow: 'Diesem Thema folgen',
                    unfollow: 'Diesem Thema nicht mehr folgen',
                    pin: 'Thema anpinnen',
                    unpin: 'Thema loslösen',
                    pinned: 'Angepinnt',
                    lock: 'Thema sperren',
                    unlock: 'Thema entsperren',
                    locked: 'Gesperrt',
                    move: 'Thema verschieben',
                    replies: 'Antworten',
                    reply: 'Antworten',
                    postCount: '{{posts, number}} Antworten',
                    empty: {
                        title: 'Noch keine Antworten',
                        description: 'Schreibe die erste Antwort auf dieses Thema.',
                    },
                    deleteDialog: {
                        title: 'Thema löschen?',
                        message: '"{{title}}" löschen?',
                        confirm: 'Thema löschen',
                    },
                    post: {
                        new: 'Neu',
                        edit: 'Antwort bearbeiten',
                        delete: 'Antwort löschen',
                        deleteDialog: {
                            title: 'Antwort löschen?',
                            message: 'Diese Antwort löschen?',
                            confirm: 'Antwort löschen',
                        },
                    },
                    moveDialog: {
                        title: 'Thema verschieben',
                        description: 'Wähle die Kategorie aus, in die dieses Thema verschoben werden soll.',
                        category: 'Kategorie',
                        categoryPlaceholder: 'Kategorie auswählen',
                        confirm: 'Thema verschieben',
                    },
                    postDialog: {
                        titleCreate: 'Antwort erstellen',
                        titleEdit: 'Antwort bearbeiten',
                        description: 'Antworten werden unter dem Thema angezeigt.',
                        message: 'Nachricht',
                        create: 'Posten',
                    },
                },
                home: {
                    title: 'Community',
                    description: 'Stelle Fragen und erhalte Hilfe von der Community rund um das Produkt',
                    categories: {
                        description: 'Wähle eine Kategorie, um Themen zu lesen oder eine neue Diskussion zu starten.',
                        create: 'Kategorie erstellen',
                        edit: 'Kategorie bearbeiten',
                        delete: 'Kategorie löschen',
                        open: 'Öffnen',
                        counts: '{{topics, number}} Themen · {{posts, number}} Antworten',
                        empty: {
                            title: 'Noch keine Kategorien',
                            description: 'Erstelle die erste Themenkategorie für Community-Diskussionen.',
                        },
                        deleteDialog: {
                            title: 'Kategorie löschen?',
                            message: '"{{title}}" und alle enthaltenen Themen und Antworten löschen?',
                            confirm: 'Kategorie löschen',
                        },
                    },
                    categoryDialog: {
                        titleCreate: 'Kategorie erstellen',
                        titleEdit: 'Kategorie bearbeiten',
                        description: 'Kategorien sind Themengruppen für die globale Community.',
                        title: 'Titel',
                        categoryDescription: 'Beschreibung',
                        create: 'Erstellen',
                    },
                },
                shared: {
                    attachments: {
                        title: 'Anhänge',
                        add: 'Anhänge hinzufügen',
                        remove: 'Anhang entfernen',
                        download: 'Anhang herunterladen',
                    },
                    topicDialog: {
                        titleCreate: 'Thema erstellen',
                        titleEdit: 'Thema bearbeiten',
                        description: 'Themen starten eine neue Community-Diskussion.',
                        topicTitle: 'Titel',
                        message: 'Nachricht',
                        create: 'Erstellen',
                    },
                },
            },
        },
        invitation: {
            title: 'Einladung akzeptieren',
            areUserAlready: 'Du bist bereits ein Benutzer dieser Organisation',
            isOwner: 'Du bist bereits Besitzer dieser Organisation und kannst diese Einladung daher nicht akzeptieren.',
            roleChangeWarning:
                'Wenn du diese Einladung akzeptierst, werden deine Rolle und deine Berechtigungen geändert.',
            info: 'Du bist bereits Benutzer dieser Organisation. Das Annehmen dieser Einladung kann dir weitere Berechtigungen geben.',
            loginWithAnotherUser: 'Mit einem anderen Benutzer anmelden',
            accept: 'Einladung akzeptieren',
            message: 'Hallo {{userName}}, du wurdest eingeladen, "{{organizationName}}" beizutreten.',
            error: {
                title: 'Einladung konnte nicht akzeptiert werden',
                subtitle: 'Der Einladungslink ist ungültig. Bitte fordere einen neuen an.',
            },
        },
        profile: {
            title: 'Benutzereinstellungen',
            personal: {
                title: 'Persönliche Informationen',
                description: 'Diese Informationen sind für andere Benutzer in deiner Organisation sichtbar',
                name: 'Dein vollständiger Name',
                email: 'Deine E-Mail-Adresse',
                changeEmail: 'E-Mail-Adresse ändern',
                language: 'Deine bevorzugte Sprache',
                timezone: 'Deine Zeitzone',
                bio: 'Ein wenig über dich',
            },
            emailChangeDialog: {
                title: 'E-Mail-Adresse ändern',
                email: 'Neue E-Mail-Adresse',
                save: 'Speichern',
            },
            security: {
                title: 'Sicherheit',
                description: 'Ändere dein Passwort und konfiguriere mehrstufige Authentifizierungsmethoden',
                securitySettings: 'Sicherheitseinstellungen öffnen',
            },
            'ui-preferences': {
                title: 'UI-Einstellungen',
                description: 'Diese Einstellungen gelten nur für diese Browser-Sitzung.',
                colorScheme: 'Bevorzugtes Farbschema',
                colorSchemeValue: {
                    system: 'Systemeinstellungen verwenden',
                    light: 'Helles Farbschema verwenden',
                    dark: 'Dunkles Farbschema verwenden',
                },
            },
            notifications: {
                title: 'Benachrichtigungen',
                description: 'Wähle aus, wie du Benachrichtigungen erhältst.',
                category: 'Kategorie',
                empty: 'Keine Benachrichtigungskategorien verfügbar',
                saved: 'Benachrichtigungseinstellungen gespeichert',
                error: 'Benachrichtigungseinstellungen konnten nicht gespeichert werden',
                targets: {
                    connect: 'Vereins-App',
                    root: 'Community',
                    admin: 'Administration',
                },
                channels: {
                    email: 'E-Mail',
                    push: 'Push',
                },
                aria: {
                    email: 'E-Mail-Benachrichtigungen für {{category}}',
                    push: 'Push-Benachrichtigungen für {{category}}',
                },
            },
            dangerZone: {
                title: 'Gefahrenzone',
                description: 'Sei vorsichtig mit den Aktionen, die du hier ausführst',
                delete: {
                    title: 'Konto löschen',
                    description:
                        'Du verlierst den Zugriff auf dein Konto und alle deine Daten werden dauerhaft gelöscht.\nAchtung, dies kann nicht rückgängig gemacht werden!',
                    action: 'Löschen',
                    confirmation: {
                        title: 'Konto löschen',
                        message:
                            'Bist du dir ganz sicher, dass du dein Konto und alle zugehörigen Daten löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
                    },
                },
            },
        },
    },
}
